import { inject, InjectionToken } from '@angular/core';
import { ADVERTISING_ID_COOKIE, ADVERTISING_ID_QUERY_PARAM } from '../constants/advertising-id.const';
import { resolveQueryCookieParam } from '../helpers/query-cookie-param/query-cookie-param.helper';
import { CookieFacade } from '../services/cookie/cookie.facade';
import { WINDOW } from './window';

/** Live resolver: call on each AGW request; do not treat inject result as a cached string. */
export type AdvertisingIdResolver = () => string | null;

export const ADVERTISING_ID: InjectionToken<AdvertisingIdResolver> = new InjectionToken<AdvertisingIdResolver>(
  'Advertising Id Token',
  {
    providedIn: 'root',
    factory: (): AdvertisingIdResolver => {
      const window: Window = inject(WINDOW);
      const cookieFacade: CookieFacade = inject(CookieFacade);

      return (): string | null =>
        resolveQueryCookieParam({
          location: window.location,
          cookieFacade,
          queryParam: ADVERTISING_ID_QUERY_PARAM,
          cookieName: ADVERTISING_ID_COOKIE,
          hostname: window.location.hostname,
        });
    },
  }
);
